import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=2be03e32&scoped=true"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"
import style0 from "./Bank.vue?vue&type=style&index=0&id=2be03e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be03e32",
  null
  
)

export default component.exports